import './theme-qasedak/index.css';

import './bootstrap-rtl.css'
import './app-rtl.css'

import './index.css';

import './orgChart.css'

